<template>
  <v-card class="pa-4 px-6" flat>
    <v-dialog max-width="500" v-model="detail">
      <v-card class="pa-4" :key="cart.id">
        <h2 class="text-center">Carrinho abandonado</h2>

        <v-row class="ma-0" dense>
          <v-col cols="12">
            <h2>Usuário:</h2>

            <span>Nome: {{ cart.name }}</span>
            <br />
            <span>E-mail: {{ cart.email }}</span>
            <br />
            <span>
              Última atualização: {{ $moment(cart.date).format("DD/MM/YYYY") }}
            </span>
            <div class="d-flex align-start mt-3">
              <span>
                Telefone: {{ cart.phoneNumber ? cart.phoneNumber : '-' }}
              </span>
              <v-btn
                  v-if="cart && cart.phoneNumber && cart.phoneNumber.length > 0"
                  class="icon_whatsapp ml-3"
                  :href="`https://api.whatsapp.com/send?1=pt_BR&phone=55${cart.phoneNumber.replace(/\D/g, '')}`"
                  target="_blank"
                  icon
                  width="15px"
                  height="15px"
              >
                <v-icon color="#25d366" size="28px">mdi-whatsapp</v-icon>
              </v-btn>
            </div>
          </v-col>
          <v-col cols="12">
            <h2>Produtos:</h2>
          </v-col>
          <v-col cols="12" v-for="item in cart.items" :key="item.id">
            <div class="pa-2 grey lighten-3 rounded">
              <span>
                Produto:
                <strong>{{ item.sku.product.productName }}</strong>
              </span>
              <br />
              <span>
                Quantidade:
                <strong>{{ item.quantity }}</strong>
              </span>
            </div>
          </v-col>
        </v-row>
      </v-card>
    </v-dialog>

    <div class="d-flex align-center">
      <h3>Carrinho abandonado</h3>
      <v-spacer></v-spacer>
      <v-btn icon @click="excel"><v-icon>mdi-download</v-icon></v-btn>
    </div>

    <v-divider class="ma-2"></v-divider>

    <v-data-table
      :items="items"
      :loading="loading"
      :headers="headers"
      loading-text="Buscando..."
      class="content-table"
      hide-default-footer
      no-data-text="Sem registros"
    >
      <template #[`item.date`]="{ item }">
        <span>{{ $moment(item.date).format("DD/MM/YYYY") }}</span>
      </template>
      <template #[`item.act`]="{ item }">
        <v-btn icon color="grey" @click="(cart = item), (detail = true)">
          <v-icon>mdi-eye</v-icon>
        </v-btn>
      </template>

      <template v-slot:footer class="ma-0 pa-0">
        <section class="ma-0 pa-0">
          <Pagination
              v-if="totalItems > pageSize"
              :currentPage="currentPage"
              :totalItems="totalItems"
              :page="page"
              :pageSize="pageSize"
              :totalPages="pageCount"
              @back-page="backPage"
              @next-page="nextPage"
          >
          </Pagination>
        </section>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import ApiService from "../../../../services/ApiService";
import Pagination from "@/views/pages/components/Pagination.vue";
export default {
  name: "Skus",
  components: {Pagination},

  props: {
    filter: Object,
  },

  created() {
    this.list();
  },

  data() {
    return {
      detail: false,
      cart: {},
      pageCount: 1,
      pageSize: 10,
      currentPage: 10,
      totalItems: 10,
      items: [],
      loading: false,
      apiService: new ApiService(),
      headers: [
        {
          text: "Nome",
          value: "name",
        },
        {
          text: "E-mail",
          value: "email",
        },
        {
          text: "Data (Última atualização)",
          value: "date",
        },
        {
          text: "",
          value: "act",
          sortable: false,
        },
      ],
      page: 1,
    };
  },

  methods: {
    list() {
      this.loading = true;
      this.apiService
        .post(
          "dashboard/cart",
          { ...this.filter, page: this.page },
          false,
        )
        .then((response) => {
          this.items = response.content.data;
          this.pageCount = response.content.pager.totalPages;
          this.totalItems = response.content.pager.totalItems;
          this.currentPage = response.content.pager.currentPage;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },

    async backPage() {
      this.page -= 1;
      await this.list();
    },

    async nextPage() {
      this.page += 1;
      await this.list();
    },

    excel() {
      this.loading = true;

      this.apiService
        .post(
          "dashexport/cart",
          { ...this.filter, page: this.page },
          false,
          false,
          false
        )
        .then((response) => {
          const excel =
            "data:application/octet-stream;base64," + response.content;
          const link = document.createElement("a");
          link.href = excel;
          link.setAttribute("download", `carrinho.xlsx`);
          document.body.appendChild(link);
          link.click();
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
  },

  watch: {
    filter: {
      deep: true,
      handler() {
        this.list();
      },
    },
  },
};
</script>

<style scoped>
.icon_whatsapp:hover {
  transform: scale(1.1);
}
</style>
